<script setup>
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  page: { type: Number, required: true },
  totalPages: { type: Number, required: true },
});

const emit = defineEmits(['change']);
const { t } = useI18n();
</script>

<template>
  <div class="flex flex-wrap items-center justify-between gap-3">
    <p class="text-sm text-lais-text-muted">
      {{
        t('REAL_ESTATE_BROKER_INVESTMENT.PAGINATION.PAGE', {
          page,
          total: Math.max(totalPages, 1),
        })
      }}
    </p>
    <div class="flex gap-2">
      <LaisPrimaryButton
        size="sm"
        variant="ghost"
        :disabled="page <= 1"
        @click="emit('change', page - 1)"
      >
        {{ t('REAL_ESTATE_BROKER_INVESTMENT.PAGINATION.PREVIOUS') }}
      </LaisPrimaryButton>
      <LaisPrimaryButton
        size="sm"
        variant="ghost"
        :disabled="page >= totalPages"
        @click="emit('change', page + 1)"
      >
        {{ t('REAL_ESTATE_BROKER_INVESTMENT.PAGINATION.NEXT') }}
      </LaisPrimaryButton>
    </div>
  </div>
</template>
